/** Public display preferences only; never include payment or customer settings. */
export type CartDisplay = {
  placement: "floating" | "header";
  position: "bottom-right" | "bottom-left";
};

export function normalizeCartDisplay(value: unknown): CartDisplay {
  const data = value && typeof value === "object" ? value as Record<string, unknown> : {};
  return {
    placement: data.placement === "header" ? "header" : "floating",
    position: data.position === "bottom-left" ? "bottom-left" : "bottom-right",
  };
}

export function effectiveCartPlacement(display: CartDisplay, headerProvided: boolean): CartDisplay["placement"] {
  return display.placement === "header" && headerProvided ? "header" : "floating";
}

export function normalizeAttributeFilterNames(value: unknown): string[] {
  const names = typeof value === "string" ? value.split(",") : Array.isArray(value) ? value : [];
  return [...new Set(names.filter((name): name is string => typeof name === "string")
    .map((name) => name.trim()).filter((name) => name.length > 0 && name.length <= 80))].slice(0, 8);
}
